export const environment = {
production: false,
apiUrl: 'https://test.tecsol-analytics.com/apiv1',
// apiUrl: 'https://deva.tecsol-analytics.com/apiv1',    // Attention => va taper sur la base de PROD !!!
basicAuthorization: 'Basic djQ6dGVjc29s',
};
